import { render, staticRenderFns } from "./TaxesList.vue?vue&type=template&id=7810eeb5&scoped=true&"
import script from "./TaxesList.vue?vue&type=script&lang=js&"
export * from "./TaxesList.vue?vue&type=script&lang=js&"
import style0 from "./TaxesList.vue?vue&type=style&index=0&id=7810eeb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810eeb5",
  null
  
)

export default component.exports